import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { QuotationRequestModel } from "@model/quotation.model";
import { TokenService } from "./token.service";


@Injectable({
    providedIn: "root",
})
export class GeneraliApiService {

    constructor(private http: HttpClient,
        private tokenService: TokenService) {
    }
    
    GetQuotation(model: QuotationRequestModel): Observable<any> {
        return this.http.post<any>("/Generali/GetQuotation",model);
    }

    refreshPolicy(referenceNumber: string): Observable<any> {
        return this.http.post<any>(
            '/Generali/RefreshPolicy?referencenumber='+referenceNumber, ''
        );
    }
}
